import React from "react";

export type TableProps = {
  children?: React.ReactNode;
};

export const Table = ({ children }: TableProps) => {
  return (
    <div className="gpc__table-container">
      <table className="gpc__table">{children}</table>
    </div>
  );
};

export default Table;
